/*
 * @Author: Teemo Ding
 * @Date: 2021-10-21 13:39:31
 * @LastEditTime: 2022-06-13 11:04:51
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelPayment/ProcessingFee/index.tsx
 */
import { Checkbox } from '@/src/components/Antd';
import Configuration from '@/src/components/Configuration/Configuration';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Form } from 'antd';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';
const ProcessingFee = ({ disableEdit }: { disableEdit?: boolean }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      // containerClassName={css.invoiceFormat}
      title={getI18n('salesChannelPayment.index.processingFee')}>
      <Form.Item
        name='enableProcessingFee'
        valuePropName='checked'
        labelCol={{ span: 24 }}>
        <Checkbox disabled={disableEdit}>
          {getI18n('salesChannelPayment.index.chargemycustomeraprocessingfee')}
        </Checkbox>
      </Form.Item>
      <Configuration
        configStart={getI18n('general.gotoStore')}
        linkTo={`/settings/payment`}
        configLink={getI18n('general.sider.settings')}
        configEnd={getI18n(
          'salesChannelPayment.index.tosetuptheprocessingfeeofeachpaymentmethod',
        )}
      />
    </SectionWrapper>
  );
};

export default ProcessingFee;
